import { useQuery } from '@tanstack/react-query';
import { getSubscription } from '../services/subscriptions.api';

export function useSubscription(id: string) {
  return useQuery({
    queryKey: ['subscriptions', 'detail', id],
    queryFn: () => getSubscription(id),
    enabled: Boolean(id),
  });
}
